import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { LegalModal } from './LegalModal';
type LegalView = 'privacy' | 'terms' | null;
export function Footer() {
  const {
    t
  } = useLanguage();
  const [openModal, setOpenModal] = useState<LegalView>(null);
  return <>
      <footer className="bg-charcoal border-t border-glass-border py-10 lg:py-[60px] px-8 lg:px-[60px]" data-id="element-49">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row justify-between items-center gap-8 text-center lg:text-left" data-id="element-50">
          <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-51">
            <div className="flex items-center gap-3" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/9mEgRo94BdLBoXFgduhDkY/logo.png" alt="Elias Navarro Law Logo" className="h-12 w-auto object-contain opacity-80" data-id="element-53" />
              <div className="flex flex-col leading-none" data-id="element-54">
                <span className="font-serif text-[14px] font-bold tracking-[3px] text-white uppercase" data-id="element-55">
                  Elias Navarro
                </span>
                <span className="text-[8px] tracking-[5px] text-gold-light uppercase font-light mt-1" data-id="element-56">
                  Law Firm
                </span>
              </div>
            </div>
            <span className="text-[11px] text-[#f5f5f5]/20 tracking-[1px]" data-id="element-57">
              {t('footer.copy')}
            </span>
          </div>

          <p className="text-[10px] text-[#f5f5f5]/15 max-w-[500px] text-center leading-[1.8] tracking-[0.3px]" data-id="element-58">
            {t('footer.disclaimer')}
          </p>

          <div className="flex gap-8" data-id="element-59">
            <button type="button" onClick={() => setOpenModal('privacy')} className="text-[10px] tracking-[2px] uppercase text-[#f5f5f5]/20 no-underline transition-colors duration-300 hover:text-crimson-glow bg-transparent border-0 cursor-pointer p-0" data-id="element-60">
              {t('footer.privacy')}
            </button>
            <button type="button" onClick={() => setOpenModal('terms')} className="text-[10px] tracking-[2px] uppercase text-[#f5f5f5]/20 no-underline transition-colors duration-300 hover:text-crimson-glow bg-transparent border-0 cursor-pointer p-0" data-id="element-61">
              {t('footer.terms')}
            </button>
            <a href="#cta" className="text-[10px] tracking-[2px] uppercase text-[#f5f5f5]/20 no-underline transition-colors duration-300 hover:text-crimson-glow" data-id="element-62">
              {t('footer.contact')}
            </a>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title={t('legal.privacy.title')} data-id="element-63">
        <p data-id="element-64">{t('legal.privacy.p1')}</p>
        <p data-id="element-65">{t('legal.privacy.p2')}</p>
        <p data-id="element-66">{t('legal.privacy.p3')}</p>
        <p data-id="element-67">{t('legal.privacy.p4')}</p>
        <p data-id="element-68">{t('legal.privacy.p5')}</p>
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title={t('legal.terms.title')} data-id="element-69">
        <p data-id="element-70">{t('legal.terms.p1')}</p>
        <p data-id="element-71">{t('legal.terms.p2')}</p>
        <p data-id="element-72">{t('legal.terms.p3')}</p>
        <p data-id="element-73">{t('legal.terms.p4')}</p>
        <p data-id="element-74">{t('legal.terms.p5')}</p>
        <p data-id="element-75">{t('legal.terms.p6')}</p>
      </LegalModal>
    </>;
}